module.exports = __webpack_public_path__ + "img/link_bullet_blue.2ece969a.svg";